var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElectrophoresisBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 58,
    viewBox: "0 -10 117 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.951172 19.1321H116.05L115.998 19.477L116.05 19.456L110.847 58H94.5905L89.7135 45.044H27.2872L22.4102 58H6.15336L0.951172 19.456L1.02195 19.4846L0.951172 19.1321Z",
    fill: "#F2F2F2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 19,
    width: 117,
    height: 39
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.951172 19.1321H116.05L115.998 19.477L116.05 19.456L110.847 58H94.5905L89.7135 45.044H27.2872L22.4102 58H6.15336L0.951172 19.456L1.02195 19.4846L0.951172 19.1321Z",
    fill: "#F2F2F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M51.9973 20.4277L15.582 56.7044L37.6913 58.3239L75.7323 20.4277H51.9973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M78.9843 20.4277L40.6182 58.6478H44.1947L82.5608 20.4277H78.9843Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3555 19.1321H15.2571V47.6352C15.2571 48.7085 14.3837 49.5786 13.3063 49.5786C12.2289 49.5786 11.3555 48.7085 11.3555 47.6352V19.1321Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.743 19.1321H105.645V47.6352C105.645 48.7085 104.771 49.5786 103.694 49.5786C102.617 49.5786 101.743 48.7085 101.743 47.6352V19.1321Z",
    fill: "#AD210C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.7135 45.044L94.5905 58H110.847L116.05 19.456L115.998 19.477L116.05 19.1321H0.951172L1.02195 19.4846L0.951172 19.456L6.15336 58H22.4102L27.2872 45.044H89.7135ZM21.5089 56.7044L26.386 43.7484H90.6147L95.4918 56.7044H109.71L114.462 21.497L114.373 21.533L114.539 20.4277H2.53758L2.77113 21.5909L2.53889 21.497L7.29074 56.7044H21.5089Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.8143 41.805H84.8361L90.6886 43.7484H26.3115L32.8143 41.805Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M6.80371 54.1132H23.7108L22.7354 56.7044H7.45398L6.80371 54.1132Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.197 54.1132H93.2902L94.2656 56.7044H109.547L110.197 54.1132Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2575 0.993713H11.3559V6.55281C9.44937 7.3216 8.10449 9.18359 8.10449 11.3585V17.8365H18.5089V11.3585C18.5089 9.18359 17.164 7.3216 15.2575 6.55281V0.993713Z",
    fill: "#444444"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2576 0.993713H13.957V6.78565C13.957 6.78568 13.957 6.78571 13.957 6.78573V6.8239H13.9999C14.0962 6.9098 14.1917 6.99395 14.286 7.07703C15.527 8.17054 16.5581 9.07907 16.5581 11.3585V17.8365H18.5089V11.3585C18.5089 9.18359 17.1641 7.3216 15.2576 6.55281V0.993713Z",
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.006 0.993713H12.6562V6.8239C12.3052 7.17364 11.9844 7.45033 11.6973 7.69803C10.6548 8.59732 10.0552 9.11456 10.0552 11.3586V17.8366H8.75462V11.3586C8.75462 9.18371 10.0995 7.32172 12.006 6.55293V0.993713Z",
    fill: "#999999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.645 0.993713H101.744V6.55281C99.8371 7.3216 98.4922 9.18359 98.4922 11.3585V17.8365H108.897V11.3585C108.897 9.18359 107.552 7.3216 105.645 6.55281V0.993713Z",
    fill: "#AD210C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.645 0.993713H104.345V6.78565C104.345 6.78568 104.345 6.78571 104.345 6.78573V6.8239H104.388C104.484 6.9098 104.579 6.99395 104.674 7.07703C105.915 8.17054 106.946 9.07907 106.946 11.3585V17.8365H108.897V11.3585C108.897 9.18359 107.552 7.3216 105.645 6.55281V0.993713Z",
    fill: "#541005"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.394 0.993713H103.044V6.8239C102.693 7.17364 102.372 7.45033 102.085 7.69803C101.042 8.59732 100.443 9.11456 100.443 11.3586V17.8366H99.1423V11.3586C99.1423 9.18371 100.487 7.32172 102.394 6.55293V0.993713Z",
    fill: "#C48686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrophoresisBox);
export default __webpack_public_path__ + "static/media/Electrophoresis_Box.1d0a724c107dcb89d2d6409a692c658b.svg";
export { ForwardRef as ReactComponent };